<p-select [options]="dropdownOptions()" [(ngModel)]="selectedOpsRegions" (onChange)="onRegionSelected($event)" (onBlur)="onTouched()" [disabled]="disabled" placeholder="Select a Region"></p-select>
